import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

// Scrolling financial ticker. Accepts items; falls back gracefully if empty.
export default function FinancialTicker({ items = [] }) {
  if (!items || items.length === 0) return null;
  const loop = [...items, ...items];

  return (
    <div className="ticker-wrap bg-[#0b3d26] border-y" style={{ borderColor: '#12523a' }}>
      <div className="max-w-[1320px] mx-auto flex items-stretch">
        <div className="hidden sm:flex items-center gap-2 px-4 bg-[#157347] text-white font-cond font-bold uppercase tracking-wider text-xs whitespace-nowrap">
          <span className="w-2 h-2 rounded-full bg-[#8be0b0] breaking-dot" />
          Markets
        </div>
        <div className="relative overflow-hidden flex-1">
          <div className="ticker-track py-2">
            {loop.map((it, i) => {
              const up = it.change >= 0;
              return (
                <span key={i} className="inline-flex items-center gap-2 px-5 text-sm whitespace-nowrap border-r border-white/10">
                  <span className="font-bold text-white font-cond tracking-wide">{it.symbol}</span>
                  <span className="text-[#cdeddb] tabular-nums">{it.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  <span className={`inline-flex items-center gap-0.5 font-semibold tabular-nums ${up ? 'text-[#4ade80]' : 'text-[#f87171]'}`}>
                    {up ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
                    {up ? '+' : ''}{it.change.toFixed(2)}%
                  </span>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
